import { Component, effect, inject } from '@angular/core';
import { Hour } from "./components/hour/hour";
import { ThirteenMinutes } from "./components/thirteen-minutes/thirteen-minutes";
import { FifteenMinutes } from "./components/fifteen-minutes/fifteen-minutes";
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { endHour, intervalMinutes, startHour } from '../../config/constants';
import { RouteTimelineService } from '../../services/route-timeline.service';

@Component({
  selector: 'app-timeline',
  standalone: true,
  imports: [
    TranslateModule,
    Hour,
    FifteenMinutes,
    ThirteenMinutes
],
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
})
export class TimelineComponent {
  private _routeTimelineService = inject(RouteTimelineService);
  private _router = inject(Router);
  
  private readonly _timelineSegments = this._routeTimelineService.timelineSegments;
  get timelineSegments() {
    return this._timelineSegments();
  }
  
  updateTimelineEveryFifteenMinute = effect(() => {  
    // check if the current route is 'custom-route' to avoid unnecessary updates
    const currentUrl = this._router.url;
    const isCustomRouteRoute = currentUrl.includes('/custom-route');
    if (!isCustomRouteRoute) return;
    
    // Program first update at 9:00 AM and end at 23:00 PM
    const firstTimeout = this._routeTimelineService.scheduleNextUpdate(intervalMinutes, startHour, endHour);
    
    // Clear the timeout when the component is destroyed
    return () => clearTimeout(firstTimeout);
  }, { allowSignalWrites: true });
}
